import {
    getApplication,
    listApplications
} from './queries';
import {
    createApplication,
    deleteApplication,
    updateApplication,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';

import {Application} from "../types.ts";
import {generateClient} from "aws-amplify/api";


export type ListApplications = {
    listApplications: { items: Application[] }
}

export type GetApplication = {
    getApplication: Application
}

export type CreateApplication = {
    createApplication: Application
}

export type UpdateApplication = {
    updateApplication: Application
}

export type DeleteApplication = {
    deleteApplication: string
}

const client = generateClient();


export const fetchRecords = async (filter: object) => {
    const response = await client.graphql<GraphQLQuery<ListApplications>>({
                                                                              query: listApplications,
                                                                              variables: {filter: filter},
                                                                          });
    return response.data?.listApplications.items;
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetApplication>>({
                                                                            query: getApplication,
                                                                            variables: {id: id},
                                                                        });
    return response.data?.getApplication;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreateApplication>>({
                                                                               query: createApplication,
                                                                               variables: {input: payload},
                                                                           });
    return response.data?.createApplication;
};

export const update = async (_id: string, record: Application) => {
    delete record.created;
    delete record.updated;

    const response = await client.graphql<GraphQLQuery<UpdateApplication>>({
                                                                               query: (updateApplication),
                                                                               variables: {input: record},
                                                                           });
    return response.data?.updateApplication;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteApplication>>({
                                                                               query: (deleteApplication),
                                                                               variables: {input: {id: id}},
                                                                           });
    return response.data?.deleteApplication;
};
